import { notifyParent } from 'mailup-react-helpers'
import { modalOptionalFilterDetailState } from 'Pages/Workflow/recoil/state/modals'

import ModalFilters from 'Components/ModalFilterDetails'
import { useRecoilValue, useResetRecoilState } from 'recoil'

export const ModalFilterDetails = () => {
  const { show, id, type, name, description } = useRecoilValue(
    modalOptionalFilterDetailState
  )

  const resetModal = useResetRecoilState(modalOptionalFilterDetailState)

  const handleClickConfirm = () => {
    notifyParent('redirectMainFrame', [
      `filters_app_redirector.aspx?r=${encodeURIComponent(`/filters/form/${id}`)}`
    ])
  }

  return (
    <ModalFilters
      show={show}
      id={id}
      name={name}
      type={type}
      description={description}
      canEdit
      onClose={resetModal}
      onEdit={handleClickConfirm}
      data-mu-test='modal-filter-details'
    />
  )
}
